var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"tooltip",staticClass:"a-tooltip",class:_vm.position,attrs:{"data-tooltip":_vm.text},on:{"click":_vm.toggleShow,"mouseover":function($event){return _vm.toggleShow($event, true)},"mouseleave":function($event){return _vm.toggleShow($event, false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }